import React from 'react';
import { Link } from 'react-router-dom'; // 1. Link ko yahan import karein
import './HeroBanner.css';

// 🌟 Cloudinary Tiya_Jewellers CDN Banner (with local fallback)
const HOME_BANNER_URL = "https://res.cloudinary.com/qujxcplu/image/upload/v1791725704/Tiya_Jewellers/Home.jpg";

const HeroBanner = () => {
    return (
        <div 
            className="hero-container"
            style={{
                backgroundImage: `url('${HOME_BANNER_URL}'), url('/Home.jpeg')`,
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minHeight: '90vh'
            }}
        >
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <h5>TRADITION MEETS LUXURY</h5>
                <h1>Crafted For Your <br /><span>Golden Moments</span></h1>
                <p>Discover our exclusive collection of timeless gold and diamond jewellery designed to make every occasion unforgettable.</p>
                <div className="hero-buttons">
                    {/* 2. Button ko Link tag se wrap kar dein */}
                    <Link to="/collection">
                        <button className="btn-primary">Explore Collection</button>
                    </Link>
                    {/* <button className="btn-secondary">Book Consultation</button> */}
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;